/** Anzeige-Regeln für Warnungen (Referenz-Chip und Sprungziel). */

interface WarnungRef {
  referenz_typ?: string | null;
  referenz_id?: number | null;
}

/** Referenz-Typen, deren Id keine sprechende Objektnummer ist: `erechnung_pflicht` zeigt auf den
    eigenen Mandanten (Sammelwarnung) — „erechnung_pflicht #1“ wäre bedeutungslos. */
const OHNE_REFERENZ_CHIP = ['erechnung_pflicht'];

/** Text des Referenz-Chips („dokument #12“); null, wenn nichts Sinnvolles anzuzeigen ist. */
export function warnungReferenzText(w: WarnungRef): string | null {
  if (!w.referenz_typ) return null;
  if (OHNE_REFERENZ_CHIP.includes(w.referenz_typ)) return null;
  return `${w.referenz_typ} #${w.referenz_id}`;
}

export interface WarnungZiel {
  label: string;
  tab: string;
}

/** Sprungziel der Warnung in der Verwaltung; null = keines. Die Sammelwarnung zu Unternehmerkunden
    ohne E-Rechnungsformat führt in die Kunden-Stammdaten, wo das Format je Kunde gesetzt wird. */
export function warnungZiel(w: WarnungRef): WarnungZiel | null {
  if (w.referenz_typ === 'erechnung_pflicht') return { label: 'Kunden öffnen', tab: 'kunden' };
  return null;
}
